// Kaynak: https://www.iban.com/country-codes ve ISO 3166-1 alpha-2
export const COUNTRIES = [
  // Avrupa
  { code: 'TR', name: 'Türkiye', region: 'Avrupa' },
  { code: 'AL', name: 'Arnavutluk', region: 'Avrupa' },
  { code: 'DE', name: 'Almanya', region: 'Avrupa' },
  { code: 'AD', name: 'Andorra', region: 'Avrupa' },
  { code: 'AT', name: 'Avusturya', region: 'Avrupa' },
  { code: 'BY', name: 'Beyaz Rusya', region: 'Avrupa' },
  { code: 'BE', name: 'Belçika', region: 'Avrupa' },
  { code: 'BA', name: 'Bosna Hersek', region: 'Avrupa' },
  { code: 'BG', name: 'Bulgaristan', region: 'Avrupa' },
  { code: 'CZ', name: 'Çekya', region: 'Avrupa' },
  { code: 'DK', name: 'Danimarka', region: 'Avrupa' },
  { code: 'EE', name: 'Estonya', region: 'Avrupa' },
  { code: 'FO', name: 'Faroe Adaları', region: 'Avrupa' },
  { code: 'FI', name: 'Finlandiya', region: 'Avrupa' },
  { code: 'FR', name: 'Fransa', region: 'Avrupa' },
  { code: 'GI', name: 'Cebelitarık', region: 'Avrupa' },
  { code: 'GR', name: 'Yunanistan', region: 'Avrupa' },
  { code: 'GG', name: 'Guernsey', region: 'Avrupa' },
  { code: 'HR', name: 'Hırvatistan', region: 'Avrupa' },
  { code: 'NL', name: 'Hollanda', region: 'Avrupa' },
  { code: 'IE', name: 'İrlanda', region: 'Avrupa' },
  { code: 'ES', name: 'İspanya', region: 'Avrupa' },
  { code: 'SE', name: 'İsveç', region: 'Avrupa' },
  { code: 'CH', name: 'İsviçre', region: 'Avrupa' },
  { code: 'IT', name: 'İtalya', region: 'Avrupa' },
  { code: 'IS', name: 'İzlanda', region: 'Avrupa' },
  { code: 'JE', name: 'Jersey', region: 'Avrupa' },
  { code: 'ME', name: 'Karadağ', region: 'Avrupa' },
  { code: 'LV', name: 'Letonya', region: 'Avrupa' },
  { code: 'LI', name: 'Lihtenştayn', region: 'Avrupa' },
  { code: 'LT', name: 'Litvanya', region: 'Avrupa' },
  { code: 'LU', name: 'Lüksemburg', region: 'Avrupa' },
  { code: 'HU', name: 'Macaristan', region: 'Avrupa' },
  { code: 'MT', name: 'Malta', region: 'Avrupa' },
  { code: 'IM', name: 'Man Adası', region: 'Avrupa' },
  { code: 'MD', name: 'Moldova', region: 'Avrupa' },
  { code: 'MC', name: 'Monako', region: 'Avrupa' },
  { code: 'MK', name: 'Kuzey Makedonya', region: 'Avrupa' },
  { code: 'NO', name: 'Norveç', region: 'Avrupa' },
  { code: 'PL', name: 'Polonya', region: 'Avrupa' },
  { code: 'PT', name: 'Portekiz', region: 'Avrupa' },
  { code: 'RO', name: 'Romanya', region: 'Avrupa' },
  { code: 'RU', name: 'Rusya', region: 'Avrupa' },
  { code: 'SM', name: 'San Marino', region: 'Avrupa' },
  { code: 'RS', name: 'Sırbistan', region: 'Avrupa' },
  { code: 'SK', name: 'Slovakya', region: 'Avrupa' },
  { code: 'SI', name: 'Slovenya', region: 'Avrupa' },
  { code: 'SJ', name: 'Svalbard ve Jan Mayen', region: 'Avrupa' },
  { code: 'UA', name: 'Ukrayna', region: 'Avrupa' },
  { code: 'GB', name: 'Birleşik Krallık', region: 'Avrupa' },
  { code: 'VA', name: 'Vatikan', region: 'Avrupa' },
  { code: 'AX', name: 'Åland Adaları', region: 'Avrupa' },

  // Amerika
  { code: 'US', name: 'Amerika Birleşik Devletleri', region: 'Amerika' },
  { code: 'AS', name: 'Amerikan Samoası', region: 'Amerika' },
  { code: 'AI', name: 'Anguilla', region: 'Amerika' },
  { code: 'AG', name: 'Antigua ve Barbuda', region: 'Amerika' },
  { code: 'AR', name: 'Arjantin', region: 'Amerika' },
  { code: 'AW', name: 'Aruba', region: 'Amerika' },
  { code: 'BS', name: 'Bahamalar', region: 'Amerika' },
  { code: 'BB', name: 'Barbados', region: 'Amerika' },
  { code: 'BZ', name: 'Belize', region: 'Amerika' },
  { code: 'BM', name: 'Bermuda', region: 'Amerika' },
  { code: 'BO', name: 'Bolivya', region: 'Amerika' },
  { code: 'BR', name: 'Brezilya', region: 'Amerika' },
  { code: 'VG', name: 'Britanya Virjin Adaları', region: 'Amerika' },
  { code: 'CA', name: 'Kanada', region: 'Amerika' },
  { code: 'KY', name: 'Cayman Adaları', region: 'Amerika' },
  { code: 'CL', name: 'Şili', region: 'Amerika' },
  { code: 'CO', name: 'Kolombiya', region: 'Amerika' },
  { code: 'CR', name: 'Kosta Rika', region: 'Amerika' },
  { code: 'CU', name: 'Küba', region: 'Amerika' },
  { code: 'CW', name: 'Curaçao', region: 'Amerika' },
  { code: 'DM', name: 'Dominika', region: 'Amerika' },
  { code: 'DO', name: 'Dominik Cumhuriyeti', region: 'Amerika' },
  { code: 'EC', name: 'Ekvador', region: 'Amerika' },
  { code: 'SV', name: 'El Salvador', region: 'Amerika' },
  { code: 'FK', name: 'Falkland Adaları', region: 'Amerika' },
  { code: 'GF', name: 'Fransız Guyanası', region: 'Amerika' },
  { code: 'GD', name: 'Grenada', region: 'Amerika' },
  { code: 'GL', name: 'Grönland', region: 'Amerika' },
  { code: 'GP', name: 'Guadeloupe', region: 'Amerika' },
  { code: 'GT', name: 'Guatemala', region: 'Amerika' },
  { code: 'GY', name: 'Guyana', region: 'Amerika' },
  { code: 'HT', name: 'Haiti', region: 'Amerika' },
  { code: 'HN', name: 'Honduras', region: 'Amerika' },
  { code: 'JM', name: 'Jamaika', region: 'Amerika' },
  { code: 'MQ', name: 'Martinik', region: 'Amerika' },
  { code: 'MX', name: 'Meksika', region: 'Amerika' },
  { code: 'MS', name: 'Montserrat', region: 'Amerika' },
  { code: 'NI', name: 'Nikaragua', region: 'Amerika' },
  { code: 'PA', name: 'Panama', region: 'Amerika' },
  { code: 'PY', name: 'Paraguay', region: 'Amerika' },
  { code: 'PE', name: 'Peru', region: 'Amerika' },
  { code: 'PR', name: 'Porto Riko', region: 'Amerika' },
  { code: 'BL', name: 'Saint Barthélemy', region: 'Amerika' },
  { code: 'KN', name: 'Saint Kitts ve Nevis', region: 'Amerika' },
  { code: 'LC', name: 'Saint Lucia', region: 'Amerika' },
  { code: 'MF', name: 'Saint Martin', region: 'Amerika' },
  { code: 'PM', name: 'Saint Pierre ve Miquelon', region: 'Amerika' },
  { code: 'VC', name: 'Saint Vincent ve Grenadinler', region: 'Amerika' },
  { code: 'SX', name: 'Sint Maarten', region: 'Amerika' },
  { code: 'SR', name: 'Surinam', region: 'Amerika' },
  { code: 'TT', name: 'Trinidad ve Tobago', region: 'Amerika' },
  { code: 'TC', name: 'Turks ve Caicos Adaları', region: 'Amerika' },
  { code: 'UY', name: 'Uruguay', region: 'Amerika' },
  { code: 'VE', name: 'Venezuela', region: 'Amerika' },
  { code: 'VI', name: 'Virgin Adaları (ABD)', region: 'Amerika' },

  // Asya
  { code: 'AF', name: 'Afganistan', region: 'Asya' },
  { code: 'AZ', name: 'Azerbaycan', region: 'Asya' },
  { code: 'BH', name: 'Bahreyn', region: 'Asya' },
  { code: 'BD', name: 'Bangladeş', region: 'Asya' },
  { code: 'AE', name: 'Birleşik Arap Emirlikleri', region: 'Asya' },
  { code: 'BN', name: 'Brunei', region: 'Asya' },
  { code: 'BT', name: 'Butan', region: 'Asya' },
  { code: 'CN', name: 'Çin', region: 'Asya' },
  { code: 'TL', name: 'Doğu Timor', region: 'Asya' },
  { code: 'ID', name: 'Endonezya', region: 'Asya' },
  { code: 'AM', name: 'Ermenistan', region: 'Asya' },
  { code: 'PH', name: 'Filipinler', region: 'Asya' },
  { code: 'PS', name: 'Filistin', region: 'Asya' },
  { code: 'GE', name: 'Gürcistan', region: 'Asya' },
  { code: 'KR', name: 'Güney Kore', region: 'Asya' },
  { code: 'IN', name: 'Hindistan', region: 'Asya' },
  { code: 'HK', name: 'Hong Kong', region: 'Asya' },
  { code: 'IQ', name: 'Irak', region: 'Asya' },
  { code: 'IR', name: 'İran', region: 'Asya' },
  { code: 'IL', name: 'İsrail', region: 'Asya' },
  { code: 'JP', name: 'Japonya', region: 'Asya' },
  { code: 'KH', name: 'Kamboçya', region: 'Asya' },
  { code: 'QA', name: 'Katar', region: 'Asya' },
  { code: 'KZ', name: 'Kazakistan', region: 'Asya' },
  { code: 'KG', name: 'Kırgızistan', region: 'Asya' },
  { code: 'CY', name: 'Kıbrıs', region: 'Asya' },
  { code: 'KW', name: 'Kuveyt', region: 'Asya' },
  { code: 'KP', name: 'Kuzey Kore', region: 'Asya' },
  { code: 'LA', name: 'Laos', region: 'Asya' },
  { code: 'LB', name: 'Lübnan', region: 'Asya' },
  { code: 'MO', name: 'Makao', region: 'Asya' },
  { code: 'MV', name: 'Maldivler', region: 'Asya' },
  { code: 'MY', name: 'Malezya', region: 'Asya' },
  { code: 'MM', name: 'Myanmar', region: 'Asya' },
  { code: 'MN', name: 'Moğolistan', region: 'Asya' },
  { code: 'NP', name: 'Nepal', region: 'Asya' },
  { code: 'UZ', name: 'Özbekistan', region: 'Asya' },
  { code: 'PK', name: 'Pakistan', region: 'Asya' },
  { code: 'SG', name: 'Singapur', region: 'Asya' },
  { code: 'LK', name: 'Sri Lanka', region: 'Asya' },
  { code: 'SY', name: 'Suriye', region: 'Asya' },
  { code: 'SA', name: 'Suudi Arabistan', region: 'Asya' },
  { code: 'TJ', name: 'Tacikistan', region: 'Asya' },
  { code: 'TH', name: 'Tayland', region: 'Asya' },
  { code: 'TW', name: 'Tayvan', region: 'Asya' },
  { code: 'TM', name: 'Türkmenistan', region: 'Asya' },
  { code: 'OM', name: 'Umman', region: 'Asya' },
  { code: 'JO', name: 'Ürdün', region: 'Asya' },
  { code: 'VN', name: 'Vietnam', region: 'Asya' },
  { code: 'YE', name: 'Yemen', region: 'Asya' },

  // Afrika
  { code: 'DZ', name: 'Cezayir', region: 'Afrika' },
  { code: 'AO', name: 'Angola', region: 'Afrika' },
  { code: 'BJ', name: 'Benin', region: 'Afrika' },
  { code: 'BW', name: 'Botsvana', region: 'Afrika' },
  { code: 'BF', name: 'Burkina Faso', region: 'Afrika' },
  { code: 'BI', name: 'Burundi', region: 'Afrika' },
  { code: 'CV', name: 'Cabo Verde', region: 'Afrika' },
  { code: 'CM', name: 'Kamerun', region: 'Afrika' },
  { code: 'CF', name: 'Orta Afrika Cumhuriyeti', region: 'Afrika' },
  { code: 'TD', name: 'Çad', region: 'Afrika' },
  { code: 'KM', name: 'Komorlar', region: 'Afrika' },
  { code: 'CG', name: 'Kongo Cumhuriyeti', region: 'Afrika' },
  { code: 'CD', name: 'Demokratik Kongo Cumhuriyeti', region: 'Afrika' },
  { code: 'CI', name: 'Fildişi Sahili', region: 'Afrika' },
  { code: 'DJ', name: 'Cibuti', region: 'Afrika' },
  { code: 'EG', name: 'Mısır', region: 'Afrika' },
  { code: 'GQ', name: 'Ekvator Ginesi', region: 'Afrika' },
  { code: 'ER', name: 'Eritre', region: 'Afrika' },
  { code: 'SZ', name: 'Esvatini', region: 'Afrika' },
  { code: 'ET', name: 'Etiyopya', region: 'Afrika' },
  { code: 'GA', name: 'Gabon', region: 'Afrika' },
  { code: 'GM', name: 'Gambiya', region: 'Afrika' },
  { code: 'GH', name: 'Gana', region: 'Afrika' },
  { code: 'GN', name: 'Gine', region: 'Afrika' },
  { code: 'GW', name: 'Gine-Bissau', region: 'Afrika' },
  { code: 'KE', name: 'Kenya', region: 'Afrika' },
  { code: 'LS', name: 'Lesotho', region: 'Afrika' },
  { code: 'LR', name: 'Liberya', region: 'Afrika' },
  { code: 'LY', name: 'Libya', region: 'Afrika' },
  { code: 'MG', name: 'Madagaskar', region: 'Afrika' },
  { code: 'MW', name: 'Malavi', region: 'Afrika' },
  { code: 'ML', name: 'Mali', region: 'Afrika' },
  { code: 'MR', name: 'Moritanya', region: 'Afrika' },
  { code: 'MU', name: 'Mauritius', region: 'Afrika' },
  { code: 'YT', name: 'Mayotte', region: 'Afrika' },
  { code: 'MA', name: 'Fas', region: 'Afrika' },
  { code: 'MZ', name: 'Mozambik', region: 'Afrika' },
  { code: 'NA', name: 'Namibya', region: 'Afrika' },
  { code: 'NE', name: 'Nijer', region: 'Afrika' },
  { code: 'NG', name: 'Nijerya', region: 'Afrika' },
  { code: 'RE', name: 'Réunion', region: 'Afrika' },
  { code: 'RW', name: 'Ruanda', region: 'Afrika' },
  { code: 'SH', name: 'Saint Helena', region: 'Afrika' },
  { code: 'ST', name: 'São Tomé ve Príncipe', region: 'Afrika' },
  { code: 'SN', name: 'Senegal', region: 'Afrika' },
  { code: 'SC', name: 'Seyşeller', region: 'Afrika' },
  { code: 'SL', name: 'Sierra Leone', region: 'Afrika' },
  { code: 'SO', name: 'Somali', region: 'Afrika' },
  { code: 'ZA', name: 'Güney Afrika', region: 'Afrika' },
  { code: 'SS', name: 'Güney Sudan', region: 'Afrika' },
  { code: 'SD', name: 'Sudan', region: 'Afrika' },
  { code: 'TZ', name: 'Tanzanya', region: 'Afrika' },
  { code: 'TG', name: 'Togo', region: 'Afrika' },
  { code: 'TN', name: 'Tunus', region: 'Afrika' },
  { code: 'UG', name: 'Uganda', region: 'Afrika' },
  { code: 'EH', name: 'Batı Sahra', region: 'Afrika' },
  { code: 'ZM', name: 'Zambiya', region: 'Afrika' },
  { code: 'ZW', name: 'Zimbabve', region: 'Afrika' },

  // Okyanusya
  { code: 'AS', name: 'Amerikan Samoası', region: 'Okyanusya' },
  { code: 'AU', name: 'Avustralya', region: 'Okyanusya' },
  { code: 'CX', name: 'Christmas Adası', region: 'Okyanusya' },
  { code: 'CC', name: 'Cocos (Keeling) Adaları', region: 'Okyanusya' },
  { code: 'CK', name: 'Cook Adaları', region: 'Okyanusya' },
  { code: 'FJ', name: 'Fiji', region: 'Okyanusya' },
  { code: 'PF', name: 'Fransız Polinezyası', region: 'Okyanusya' },
  { code: 'GU', name: 'Guam', region: 'Okyanusya' },
  { code: 'HM', name: 'Heard Adası ve McDonald Adaları', region: 'Okyanusya' },
  { code: 'KI', name: 'Kiribati', region: 'Okyanusya' },
  { code: 'MH', name: 'Marshall Adaları', region: 'Okyanusya' },
  { code: 'FM', name: 'Mikronezya', region: 'Okyanusya' },
  { code: 'NR', name: 'Nauru', region: 'Okyanusya' },
  { code: 'NC', name: 'Yeni Kaledonya', region: 'Okyanusya' },
  { code: 'NZ', name: 'Yeni Zelanda', region: 'Okyanusya' },
  { code: 'NU', name: 'Niue', region: 'Okyanusya' },
  { code: 'NF', name: 'Norfolk Adası', region: 'Okyanusya' },
  { code: 'MP', name: 'Kuzey Mariana Adaları', region: 'Okyanusya' },
  { code: 'PW', name: 'Palau', region: 'Okyanusya' },
  { code: 'PG', name: 'Papua Yeni Gine', region: 'Okyanusya' },
  { code: 'PN', name: 'Pitcairn Adaları', region: 'Okyanusya' },
  { code: 'WS', name: 'Samoa', region: 'Okyanusya' },
  { code: 'SB', name: 'Solomon Adaları', region: 'Okyanusya' },
  { code: 'TK', name: 'Tokelau', region: 'Okyanusya' },
  { code: 'TO', name: 'Tonga', region: 'Okyanusya' },
  { code: 'TV', name: 'Tuvalu', region: 'Okyanusya' },
  { code: 'VU', name: 'Vanuatu', region: 'Okyanusya' },
  { code: 'WF', name: 'Wallis ve Futuna', region: 'Okyanusya' },
  
  // Diğer
  { code: 'AQ', name: 'Antarktika', region: 'Diğer' },
  { code: 'BV', name: 'Bouvet Adası', region: 'Diğer' },
  { code: 'IO', name: 'Britanya Hint Okyanusu Toprakları', region: 'Diğer' },
  { code: 'TF', name: 'Fransız Güney ve Antarktika Toprakları', region: 'Diğer' },
  { code: 'GS', name: 'Güney Georgia ve Güney Sandwich Adaları', region: 'Diğer' }
];
